import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { KeyboardIcon, WandShineIcon } from "@dotnet/telematics-design-system";

import { PAYLOAD_ID } from "../../types/enums";
import Box from "./Box";
import EnteredPassword from "./EnteredPassword";
import { BluetoothPasswordProps, PASSWORD_SOURCE } from "./types";

const BluetoothPassword = ({
    passwordSource,
    password,
    changePayload,
    changePasswordSource,
    changePassword
}: BluetoothPasswordProps) => {
    const { t } = useTranslation();

    const isEntered = passwordSource === PASSWORD_SOURCE.UserEntered;
    const isGenerated = passwordSource === PASSWORD_SOURCE.SystemGenerated;

    const handleUserGeneratedClick = () => {
        changePasswordSource(PASSWORD_SOURCE.UserEntered);
        changePayload(null);
    };

    const handleSystemGeneratedClick = () => {
        changePasswordSource(PASSWORD_SOURCE.SystemGenerated);

        changePayload({
            id: PAYLOAD_ID.Attributes,
            value: JSON.stringify({
                password_source: PASSWORD_SOURCE.SystemGenerated
            })
        });
    };

    return (
        <>
            <div css={css({ display: "flex", columnGap: "16px" })}>
                <Box
                    title={t(`Attributes##${PASSWORD_SOURCE.UserEntered}`)}
                    description={t(
                        `Dialog##set bluetooth password##${PASSWORD_SOURCE.UserEntered}##description`
                    )}
                    icon={<KeyboardIcon />}
                    isSelected={isEntered}
                    onClick={handleUserGeneratedClick}
                />

                <Box
                    title={t(`Attributes##${PASSWORD_SOURCE.SystemGenerated}`)}
                    description={t(
                        `Dialog##set bluetooth password##${PASSWORD_SOURCE.SystemGenerated}##description`
                    )}
                    icon={<WandShineIcon />}
                    isSelected={isGenerated}
                    onClick={handleSystemGeneratedClick}
                />
            </div>

            {isEntered && (
                <EnteredPassword
                    password={password}
                    changePayload={changePayload}
                    changePassword={changePassword}
                />
            )}
        </>
    );
};

export default BluetoothPassword;
